import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useLoginMutation } from "../../redux/api/adminApi";
import FullPageLoader from "components/FullPageLoader/FullPageLoader";
import { NavLink } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import validator from "validator";
import { ENV } from "../../config/config";
import { useTheme } from "../../hooks/useTheme";
import colorLogo from "../../assets/images/color-logo.png";
import whiteLogo from "../../assets/images/white-logo.png";
var CryptoJS = require("crypto-js");

// react-bootstrap components
import { Button, Card, Form, Container, Col } from "react-bootstrap";

function Login() {
  const history = useHistory();
  const { theme } = useTheme();
  const currentLogo = theme === "light" ? colorLogo : whiteLogo;
  const [user, setUser] = useState({ email: "", password: "" });
  const [msg, setMsg] = useState({ emailMsg: "", passwordMsg: "" });
  const [showPassword, setShowPass] = useState(false);
  const [login, { isLoading }] = useLoginMutation();

  const onChange = (e) => {
    let { name, value } = e.target;
    let data = user;
    data[name] = value;
    setUser({ ...data });
  };

  const submit = async () => {
    let check = true;
    if (validator.isEmpty(user.email)) {
      check = false;
      setMsg({ emailMsg: "Email is Required" });
    } else if (!validator.isEmail(user.email)) {
      check = false;
      setMsg({ emailMsg: "Invalid Email" });
    }

    if (validator.isEmpty(user.password)) {
      check = false;
      setMsg({ passwordMsg: "Password is required" });
    }

    if (check) {
      setMsg({ emailMsg: "", passwordMsg: "" });
      try {
        const result = await login(user).unwrap();
        // Handle successful login
        // result is the data object (already transformed by baseQuery)
        if (result) {
          const { roleId, accessToken, id } = result;
          if (roleId) {
            var encryptedRole = CryptoJS.AES.encrypt(
              String(roleId),
              ENV.secretKey
            ).toString();
            localStorage.setItem("role", encryptedRole);
          }
          if (accessToken) {
            localStorage.setItem("accessToken", accessToken);
          }
          if (id) {
            localStorage.setItem("userID", id);
          }
          history.push("/dashboard");
        }
      } catch (error) {
        // Error is already handled by baseApi toast
        console.error("Login failed:", error);
      }
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      submit();
    }
  };

  return (
    <>
      {isLoading ? (
        <FullPageLoader />
      ) : (
        <div className="full-page section-image" data-color="black">
          <div className="content d-flex align-items-center p-0">
            <Container>
              <Col className="mx-auto" lg="4" md="4">
                <Form action="" className="form" method="">
                  <Card className="card-login">
                    {/* <h3 className="header text-center">Login</h3> */}
                    <Card.Header className="text-center">
                      <div className="logo-holder d-inline-block align-top">
                        <img src={currentLogo} className="img-fluid" alt="" />
                      </div>
                    </Card.Header>
                    <Card.Body>
                        <Form.Group onKeyPress={handleKeyPress}>
                          <label>
                            Email address <span>*</span>
                          </label>
                          <Form.Control
                            placeholder="Enter email"
                            type="text"
                            name="email"
                            onChange={(e) => onChange(e)}
                            defaultValue={user.email}
                          />
                          <span className={msg.emailMsg ? `` : `d-none`}>
                            <label className="pl-1">{msg.emailMsg}</label>
                          </span>
                        </Form.Group>
                        <Form.Group onKeyPress={handleKeyPress}>
                          <label>
                            Password
                            <span>*</span>
                          </label>
                          <div className="password-input-wrapper" style={{ position: 'relative' }}>
                            <Form.Control
                              placeholder="Enter Password"
                              value={user.password}
                              type={showPassword ? "text" : "password"}
                              name="password"
                              onChange={(e) => onChange(e)}
                              defaultValue={user.password}
                              style={{ paddingRight: '40px' }}
                            />
                            {showPassword ? (
                              <FaEye
                                onClick={() => setShowPass(!showPassword)}
                                style={{
                                  position: 'absolute',
                                  right: '15px',
                                  top: '50%',
                                  transform: 'translateY(-50%)',
                                  cursor: 'pointer',
                                  color: 'var(--text-secondary)',
                                  zIndex: 10,
                                  opacity: user.password ? 1 : 0.5
                                }}
                              />
                            ) : (
                              <FaEyeSlash
                                onClick={() => setShowPass(!showPassword)}
                                style={{
                                  position: 'absolute',
                                  right: '15px',
                                  top: '50%',
                                  transform: 'translateY(-50%)',
                                  cursor: 'pointer',
                                  color: 'var(--text-secondary)',
                                  zIndex: 10,
                                  opacity: user.password ? 1 : 0.5
                                }}
                              />
                            )}
                          </div>
                          <span className={msg.passwordMsg ? `` : `d-none`}>
                            <label className="pl-1">{msg.passwordMsg}</label>
                          </span>
                        </Form.Group>
                        <div className="d-flex justify-content-between align-items-center">
                          <Form.Check className="pl-0"></Form.Check>
                          <NavLink
                            to="/forgot-password"
                            className="btn-no-bg"
                            type="submit"
                            variant="warning"
                          >
                            Forgot Password ?
                          </NavLink>
                        </div>
                    </Card.Body>
                    <Card.Footer className="ml-auto mr-auto">
                      <Button
                        className="btn-filled"
                        type="button"
                        disabled={isLoading}
                        onClick={() => submit()}
                      >
                        Login
                      </Button>
                    </Card.Footer>
                  </Card>
                </Form>
              </Col>
            </Container>
          </div>
          <div
            className="full-page-background"
            style={{
              background:
                "transparent linear-gradient(224deg, var(--accent-primary) 0%, var(--background-dark) 100%) 0% 0% no-repeat padding-box",
            }}
          ></div>
        </div>
      )}
    </>
  );
}

export default Login;
